import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { useAzureSignIn } from './useAzureSignIn';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  status: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  successIcon: {
    color: theme.palette.success.main,
  },
}));

// Scaffolder field that triggers an interactive Entra sign-in against the
// `microsoft-az-user` provider and stores the resulting access token in the template secrets.
const AzUserToken = () => {
  const classes = useStyles();
  const { status, user } = useAzureSignIn();

  const renderStatus = () => {
    if (status === 'gettingToken') {
      return (
        <Typography variant="body2" component="span" className={classes.status}>
          <CircularProgress size={16} />
          Signing in to Azure...
        </Typography>
      );
    }

    if (status === 'idle') {
      return (
        <Typography variant="body2" component="span" className={classes.status}>
          Preparing Azure sign-in...
        </Typography>
      );
    }

    if (status === 'error') {
      return (
        <Typography variant="body2" color="error" component="span" className={classes.status}>
          <ErrorOutlineIcon fontSize="small" />
          Azure sign-in failed. Please reload to try again.
        </Typography>
      );
    }

    const signedInName = user?.name;
    const showUsername = user?.username && user.username !== user.name;

    return (
      <Typography variant="body2" component="span" className={classes.status}>
        <CheckCircleOutlineIcon fontSize="small" className={classes.successIcon} />
        Signed in as <strong>{signedInName}</strong>
        {showUsername ? ` (${user?.username})` : ''}
      </Typography>
    );
  };

  return (
    <div className={classes.container}>
      <Typography variant="body2" component="span">
        Please use an account that can create Azure resources.
      </Typography>
      {renderStatus()}
    </div>
  );
};

export const azUserTokenField = {
  name: 'AzUserToken',
  component: AzUserToken,
};

export const AzUserTokenExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension(azUserTokenField),
);
